module.exports = __webpack_public_path__ + "static/media/pen.c5143643.png";